import "./popup.style.scss";
import { ReactComponent as IconClose } from "../../assets/icons/close.svg";
export const Popup = ({closeAction, children, classes = ""})=>{
    return (
        <div className={`popup-wrapper ${classes}`.trim()} data-aos="fade">
            <div className="popup-bg"></div>
            <div className="popup-container">
                <button className="popup-close" onClick={closeAction}><IconClose/></button>
                <div className="popup-body">
                    {children}
                </div>
            </div>
        </div>
    )
}
